// extracted by mini-css-extract-plugin
export var item = "FeatureCategories-module--item--2af1d";